import { createSelector } from '@reduxjs/toolkit';

import { citiesSelector } from 'redux/selectors/regionSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

const getLocation = (...locations: (string | number | undefined)[]) => {
  return locations.filter(Boolean).join(', ');
};

const createCitiesSelector = () =>
  createSelector(
    [
      (args: { stateId?: number }) => args.stateId,
      () => useAppSelector(citiesSelector),
    ],
    (stateId, cities) => cities.filter((city) => city.stateId === stateId),
  );

const isAddressDifferent = (address1?: string, address2?: string) => {
  const trimmedAddress1 = (address1 || '').trim().toLowerCase();
  const trimmedAddress2 = (address2 || '').trim().toLowerCase();
  return trimmedAddress1 !== trimmedAddress2;
};

export { getLocation, createCitiesSelector, isAddressDifferent };
